import { createDefaultTyrann } from '@apis/common';
import { memberUser } from '@models/Member';
import { adminUser, dashboardUsersQuery } from '@models/User';
import * as t from 'io-ts';

export const userApis = createDefaultTyrann({
  '/dashboard/user/': {
    get: {
      query: dashboardUsersQuery,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(memberUser),
        }),
      },
    },
  },
  '/dashboard/user/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: adminUser,
      },
    },
  },
});
